const applets = [
    {
        "text": "Basic Information",
        "icon": "/image/dockIcon/member.svg",
        "id": "MemberApplet",
        "path": "member",
    },
    {
        "text": "Enrollment Query",
        "icon": "/image/dockIcon/enrollment-query.svg",
        "id": "EnrollmentQueryApplet",
        "path": "enrollmentQuery",
    },
    {
        "text": "Satisfaction Survey",
        "icon": "/image/dockIcon/satisfaction-survey.svg",
        "id": "SatisfactionSurveyApplet",
        "path": "satisfactionSurvey",
    },
]


export default applets;